import React from 'react';
import { CompleteKundali, Language, ChartStyle } from '../../types/kundali';
import { PresentationRole } from '../../types/role';
import { AdvancedLifeAnalysisResult, LifeThemeId } from '../../types/advancedLifeAnalysis';
import { BasicAnalysisView } from './BasicAnalysisView';
import { ProAnalysisView } from './ProAnalysisView';
import { AcharyaConsultationView } from './AcharyaConsultationView';
import { ManagementWorkspace } from '../management/ManagementWorkspace';

interface RolePresentationRouterProps {
  activeRole: PresentationRole;
  kundali: CompleteKundali;
  analysisResult: AdvancedLifeAnalysisResult;
  selectedThemeId: LifeThemeId;
  onSelectTheme: (id: LifeThemeId) => void;
  selectedQuestionId: string;
  onSelectQuestion: (id: string) => void;
  lang: Language;
  chartStyle: ChartStyle;
  setChartStyle: (style: ChartStyle) => void;
  onOpenReasoningModal: () => void;
  onOpenPrintReport: (mode?: 'BASIC' | 'PRO' | 'ACHARYA') => void;
  onSwitchRole: (role: PresentationRole) => void;
  aiQuota: { remaining: number; allowance: number; resetDate?: string } | null;
  customQuestionInput: string;
  onCustomQuestionChange: (val: string) => void;
  onRequestAiAnalysis: () => void;
  isAiLoading: boolean;
  aiInterpretation: string;
  aiError: string;
}

export const RolePresentationRouter: React.FC<RolePresentationRouterProps> = ({
  activeRole,
  kundali,
  analysisResult,
  selectedThemeId,
  onSelectTheme,
  selectedQuestionId,
  onSelectQuestion,
  lang,
  chartStyle,
  setChartStyle,
  onOpenReasoningModal,
  onOpenPrintReport,
  onSwitchRole,
  aiQuota,
  customQuestionInput,
  onCustomQuestionChange,
  onRequestAiAnalysis,
  isAiLoading,
  aiInterpretation,
  aiError
}) => {
  switch (activeRole) {
    case 'BASIC':
      return (
        <BasicAnalysisView
          kundali={kundali}
          analysisResult={analysisResult}
          selectedThemeId={selectedThemeId}
          onSelectTheme={onSelectTheme}
          selectedQuestionId={selectedQuestionId}
          onSelectQuestion={onSelectQuestion}
          lang={lang}
          chartStyle={chartStyle}
          setChartStyle={setChartStyle}
          onOpenPrintReport={onOpenPrintReport}
          onSwitchRole={() => onSwitchRole('PRO')}
        />
      );

    case 'ACHARYA':
      return (
        <AcharyaConsultationView
          kundali={kundali}
          analysisResult={analysisResult}
          selectedThemeId={selectedThemeId}
          onSelectTheme={onSelectTheme}
          selectedQuestionId={selectedQuestionId}
          onSelectQuestion={onSelectQuestion}
          lang={lang}
          chartStyle={chartStyle}
          setChartStyle={setChartStyle}
          onOpenPrintReport={onOpenPrintReport}
          aiQuota={aiQuota}
          customQuestionInput={customQuestionInput}
          onCustomQuestionChange={onCustomQuestionChange}
          onRequestAiAnalysis={onRequestAiAnalysis}
          isAiLoading={isAiLoading}
          aiInterpretation={aiInterpretation}
          aiError={aiError}
        />
      );

    case 'MANAGEMENT':
      return (
        <ManagementWorkspace
          kundali={kundali}
          lang={lang}
          onOpenProAnalysis={(caseItem) => {
            onSwitchRole('PRO');
          }}
          onOpenAcharyaConsultation={(caseItem) => {
            onSwitchRole('ACHARYA');
          }}
        />
      );

    case 'PRO':
    default:
      return (
        <ProAnalysisView
          kundali={kundali}
          analysisResult={analysisResult}
          selectedThemeId={selectedThemeId}
          onSelectTheme={onSelectTheme}
          selectedQuestionId={selectedQuestionId}
          onSelectQuestion={onSelectQuestion}
          lang={lang}
          chartStyle={chartStyle}
          setChartStyle={setChartStyle}
          onOpenReasoningModal={onOpenReasoningModal}
          onOpenPrintReport={onOpenPrintReport}
          aiQuota={aiQuota}
          customQuestionInput={customQuestionInput}
          onCustomQuestionChange={onCustomQuestionChange}
          onRequestAiAnalysis={onRequestAiAnalysis}
          isAiLoading={isAiLoading}
          aiInterpretation={aiInterpretation}
          aiError={aiError}
        />
      );
  }
};
